import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from './components/modal/modal.component';
import { ConfirmService, ConfirmState, ConfirmTemplateDirective, ConfirmModalComponent } from './services/confirm-modal-and-service';
import { ReplacePipe } from './pipes/replace.pipe';
import { VitalParamsPipeModule } from './routes/screen/pipes/vital-params-pipe.module';
import { MomentDatePipe } from './pipes/moment-date.pipe';
import { BodyPositionPipe } from './pipes/body-position.pipe';
import { PaswordStrengthComponent } from './routes/users/user-form/user-form-tab-common/pasword-strength/pasword-strength.component';


@NgModule({
  declarations: [
    ModalComponent,
    ConfirmModalComponent,
    ConfirmTemplateDirective,
    ReplacePipe,
    MomentDatePipe,
    BodyPositionPipe,
    PaswordStrengthComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    VitalParamsPipeModule,
  ],
  exports: [
    TranslateModule,
    ReactiveFormsModule,
    CommonModule,
    ModalComponent,
    ConfirmTemplateDirective,
    ConfirmModalComponent,
    ReplacePipe,
    MomentDatePipe,
    BodyPositionPipe,
    VitalParamsPipeModule,
    PaswordStrengthComponent
  ],
  providers: [
    ConfirmService, ConfirmState
  ]
})

export class SharedModule { }
